import React, { useContext } from "react";
import { AppContext, BookingData } from "../../../AppDataProvider/AppDataProvider";
import { gap, marginBottom, typography } from "../../../common/styles";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ActionType } from "../../../AppDataProvider/actions";
import { Link } from "../../../common/components";
import { applyOpacity } from "../../../common/styles/utils";
import { requireBookingDataFields } from "../../../utils";
import { PartRequired } from "../../../utils/types";
import { Timezone } from "./TimezoneList/TimezoneList";
import { useTimezones } from "./utils";
export type TimezoneSelectorBookingData = PartRequired<BookingData, "timezone">;
type TimezoneSelectorProps = {
  disabled?: boolean;
};
export function TimezoneSelector(props: TimezoneSelectorProps) {
  const {
    disabled
  } = props;
  const {
    t
  } = useTranslation();
  const {
    appData,
    appDataDispatch
  } = useContext(AppContext);
  const {
    bookingData
  } = appData;
  const timezones = useTimezones(t);
  requireBookingDataFields<TimezoneSelectorBookingData>(bookingData, ["timezone"]);
  const {
    timezone: timezoneId
  } = bookingData;
  const timezone = timezones.find(tz => tz.id === timezoneId) as Timezone;
  return <Container data-sentry-element="Container" data-sentry-component="TimezoneSelector" data-sentry-source-file="TimezoneSelector.tsx">
      <Label data-sentry-element="Label" data-sentry-source-file="TimezoneSelector.tsx">{t("timezone")}</Label>
      <OpenSelectorLink aria-label={t("changeTimezoneButtonLabel")} aria-disabled={disabled} onClick={() => {
      if (disabled) return;
      appDataDispatch({
        payload: {
          variant: "timezoneSelector"
        },
        type: ActionType.SHOW_NON_MODAL_DIALOG
      });
    }} data-sentry-element="OpenSelectorLink" data-sentry-source-file="TimezoneSelector.tsx">
        {timezone.name}
      </OpenSelectorLink>
    </Container>;
}
const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  ${gap.s}
  ${typography.small}
  ${marginBottom.m}
`;
const Label = styled.div`
  color: ${({
  theme
}) => applyOpacity(theme.colours.dark, 0.6, false)};
  text-transform: capitalize;
`;
const OpenSelectorLink = styled(Link)`
  text-transform: capitalize;
  ${typography.small}
`;
export default TimezoneSelector;